// src/stories/Modals/ConfirmSubmissionModal.jsx
import React from "react";
import PropTypes from "prop-types";
import "../../assets/scss/_confirmsubmissionmodal.scss";

const CloseIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0001 13.4142L4.70718 20.7071L3.29297 19.2929L10.5859 12L3.29297 4.70712L4.70718 3.29291L12.0001 10.5858L19.293 3.29291L20.7072 4.70712L13.4143 12L20.7072 19.2929L19.293 20.7071L12.0001 13.4142Z"
      fill="#33333F"
    />
  </svg>
);
const ConfirmSubmissionModal = ({
  isOpen,
  onClose,
  onConfirm,
  isSubmitting,
  missingFields,
}) => {
  if (!isOpen) return null;
  return (
    <div className="confirm-submission-overlay">
      <div
        className="confirm-submission-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-submission-title"
      >
        <div className="confirm-submission-modal__header">
          <h2
            id="confirm-submission-title"
            className="confirm-submission-modal__title"
          >
            Confirm Submission
          </h2>
          <button
            type="button"
            className="confirm-submission-modal__close"
            onClick={onClose}
            aria-label="Close"
          >
            <CloseIcon />
          </button>
        </div>
        <div className="confirm-submission-modal__body">
          <p className="confirm-submission-modal__subtitle">
            Are you sure you want to submit?
          </p>
          <p className="confirm-submission-modal__description">
            Once submitted, results cannot be edited and will become read-only.
            Please ensure all information is correct before continuing.
          </p>

          {missingFields.length > 0 && (
            <div className="confirm-submission-modal__missing">
              <p className="confirm-submission-modal__missing-title">
                The following measurements are missing:
              </p>
              <ol className="confirm-submission-modal__missing-list">
                {missingFields.map((field) => (
                  <li key={field}>{field}</li>
                ))}
              </ol>
              <p className="confirm-submission-modal__missing-note">
                If this is not correct, please cancel and complete the missing
                measurements before submitting.
              </p>
            </div>
          )}
        </div>
        <div className="confirm-submission-modal__footer">
          <button
            type="button"
            className="confirm-submission-modal__cancel"
            onClick={onClose}
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            type="button"
            className="confirm-submission-modal__confirm"
            onClick={onConfirm}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Submitting..." : "Confirm & Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};

ConfirmSubmissionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
  missingFields: PropTypes.arrayOf(PropTypes.string),
};

ConfirmSubmissionModal.defaultProps = {
  isSubmitting: false,
  missingFields: [],
};

export default ConfirmSubmissionModal;
